import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from 'components/Card';
import Modal from 'components/Modal';
import Button from 'components/UI/Button';
import { ROUTE_PATH } from 'routes';
import useKLU from 'hooks/useKLU';
import PropTypes from 'prop-types';
import useLiterals from 'utils/hooks/useLiterals';

const UserKLU = ({
  titleNoUser = '',
  textNoUser = '',
  buttonNoUser = '',
  imgWidthNoUser = '',
  imgPositionNoUser = '',
  imgNoUser = null,
  warningNoUser = '',
  titleUser = '',
  textUser = '',
  buttonUser = '',
  imgWidthUser = '',
  imgPositionUser = '',
  imgUser = null,
  isPreview = false,
}) => {
  const literals = useLiterals('common');
  const [showModal, setShowModal] = useState(false);
  const klu = useKLU();
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate(ROUTE_PATH.KLU);
  };

  const handleOpenModal = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    if (warningNoUser) {
      setShowModal(true);
    } else {
      handleContinue();
    }
  };

  if (!klu.enabled && !isPreview) {
    return null;
  }

  const renderCardAccount = () => {
    return (
      <>
        {titleUser && <h2 className='mb-4'>{titleUser}</h2>}
        <Card
          className='card-klu'
          title={textUser}
          image={imgUser}
          onClick={handleContinue}
          link={buttonUser ? {
            archor: buttonUser,
            type: 'button',
          } : null}
          imgWidth={imgWidthUser}
          imgAlignment='center'
          imgPosition={imgPositionUser}
        />
      </>
    );
  };

  const renderCardNoUser = () => {
    return (
      <>
        {titleNoUser && <h2 className='mb-4'>{titleNoUser}</h2>}
        <Card
          className='card-klu'
          title={textNoUser}
          image={imgNoUser}
          onClick={handleOpenModal}
          link={buttonNoUser ? {
            archor: buttonNoUser,
            type: 'button',
          } : null}
          imgWidth={imgWidthNoUser}
          imgAlignment='center'
          imgPosition={imgPositionNoUser}
        />
      </>
    );
  };

  return (
    <>
      {!klu?.account || isPreview ? renderCardNoUser() : null}
      {klu?.account || isPreview ? renderCardAccount() : null}
      {showModal && (
        <Modal
          onClose={() => setShowModal(false)}
          position='end'
        >
          <p className='mt-4'>{warningNoUser}</p>
          <div className='mt-6'>
            <Button className='mb-1' text={literals.continue} to={ROUTE_PATH.KLU} />
            <Button className='text-primary mb-0' uppercase={false} text={literals.haveKluAccount} type='link' to={ROUTE_PATH.setKlu(true)} />
          </div>
        </Modal>
      )}
    </>
  );
};

UserKLU.propTypes = {
  titleNoUser: PropTypes.string,
  textNoUser: PropTypes.string,
  buttonNoUser: PropTypes.string,
  imgWidthNoUser: PropTypes.string,
  imgPositionNoUser: PropTypes.string,
  warningNoUser: PropTypes.string,
  imgNoUser: PropTypes.object,
  titleUser: PropTypes.string,
  textUser: PropTypes.string,
  buttonUser: PropTypes.string,
  imgWidthUser: PropTypes.string,
  imgPositionUser: PropTypes.string,
  imgUser: PropTypes.object,
  isPreview: PropTypes.bool,
};

export default UserKLU;
